import axios from 'axios'
import appConfig from 'configs/app.config'
import { TOKEN_TYPE, REQUEST_HEADER_AUTH_KEY } from 'constants/api.constant'
import { handleSubscriptionBlockedApiResponse } from 'utils/subscriptionAccess'
import { getAuthContext } from 'utils/getAuthContext'
import { getContestCompanyContext } from 'utils/contestCompanyContext'
import store from '../store'
import { onSignOutSuccess } from '../store/auth/sessionSlice'

const unauthorizedCode = [401]

const BaseService = axios.create({
    timeout: 60000,
    baseURL: appConfig.apiPrefix,
})

BaseService.interceptors.request.use(config => {
    const { token, companyId, userId } = getAuthContext()

    config.headers = config.headers || {}

    if (token) {
        config.headers[REQUEST_HEADER_AUTH_KEY] = `${TOKEN_TYPE}${token}`
    }

    // Always attach orgId when available. Controllers require this header.
    // Prefer explicit per-request orgId, then admin contest customer context, then session company.
    const existingOrgId = config.headers.orgId || config.headers.OrgId
    if (!existingOrgId) {
        const contestContext = getContestCompanyContext()
        const contextOrgId = contestContext?.companyId ? String(contestContext.companyId).trim() : ''
        if (contextOrgId) {
            config.headers.orgId = contextOrgId
        } else if (companyId) {
            config.headers.orgId = companyId
        }
    }

    const existingUserId = config.headers.userId || config.headers.UserId
    if (!existingUserId && userId) {
        config.headers.userId = userId
    }

    return config
}, error => {
    return Promise.reject(error)
})

BaseService.interceptors.response.use(
    response => response,
    error => {
        const { response } = error

        if (response) {
            handleSubscriptionBlockedApiResponse(response.status, response.data)

            if (unauthorizedCode.includes(response.status)) {
                store.dispatch(onSignOutSuccess())
            }
        }

        return Promise.reject(error)
    }
)

export default BaseService
